import { authApi } from "../utils/httpClient";

export type BillingPaymentStatus = "PAID" | "PENDING" | "FAILED" | "CANCELLED";

export type BillingTransaction = {
  _id: string;

  clientId: string; // stored as ObjectId in backend, returned as string from .lean()
  planId?: string;
  deviceId?: string;

  fileUrl: string;
  invoiceNo?: string;

  amount: number;
  currency: string;

  paidAt?: string;
  periodStart?: string;
  periodEnd?: string;

  paymentStatus: BillingPaymentStatus;
  note?: string;

  createdAt?: string;
  updatedAt?: string;
};

export type ListByClientResponse = {
  data: BillingTransaction[];
  total: number;
};

export async function listBillingTransactionsByClient(params: {
  clientId: string;
  limit: number;
  offset: number;
}): Promise<ListByClientResponse> {
  const { clientId, limit, offset } = params;

  const res = await authApi.get(`/billing-transactions/by-client/${clientId}`, {
    params: { limit, offset },
  });

  // backend returns { data, total }
  return res.data as ListByClientResponse;
}
